import { BusinessVisitRepository } from '../repositories/BaseRepository';


export const createBusinessVisitService = (businessVisitRepository: BusinessVisitRepository) => ({
  async trackVisit(businessId: number) {
    try {
      // Get user's IP address
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      const ipAddress = data.ip;

      // Check if visit exists
      const existingVisit = await businessVisitRepository.findByBusinessAndIp(businessId, ipAddress);


      if (existingVisit) {
        // Update visit count
        await businessVisitRepository.incrementVisitCount(existingVisit.id);
      } else {
        // Create new visit record
        await businessVisitRepository.create({
          business_id: businessId,
          ip_address: ipAddress,
          visit_count: 1,
        });
      }
    } catch (error) {
      console.error('Error tracking visit:', error);
      // Don't throw error to prevent disrupting user experience
    }
  },
}); 